import { splitError } from '@/helper/splitError'

/**
 * Returns all error messages
 */
const beErrorGetAllMessages = function () {
  return this.$store.getters.peekMessages
}

/**
 * Returns the last added error messages
 */
const beErrorGetLastMessage = function () {
  const errors = this.$store.getters.peekMessages
  if (errors && errors.length > 0) {
    if (errors[errors.length - 1]?.type !== 'success') {
      return errors[errors.length - 1]?.message ? errors[errors.length - 1].message : null
    }
  }

  return null
}

/**
 * Returns the last added error code
 */
const beErrorGetLastErrorCode = function () {
  const errors = this.$store.getters.peekMessages
  if (errors && errors.length > 0) {
    if (errors[errors.length - 1]?.type !== 'success') {
      return errors[errors.length - 1]?.extensions?.magma_code ? errors[errors.length - 1]?.extensions.magma_code : null
    }
  }

  return null
}

/**
 * Checks if there're any errors
 */
const beHasErrorMessages = function () {
  const errors = this.$store.getters.peekMessages
  for (let i = 0; i < errors?.length; i++) {
    if (errors[i]?.type !== 'success') {
      return true
    }
  }

  return false
}

/**
 * Checks if there're any errors
 */
const beHasSuccessMessage = function () {
  const errors = this.$store.getters.peekMessages
  for (let i = 0; i < errors?.length; i++) {
    if (errors[i]?.type === 'success') {
      return true
    }
  }

  return false
}

/**
 * Checks if there're any errors
 */
const beHasMessages = function () {
  return this.$store.getters.hasMessages
}

/**
 * Returns the last added error category
 */
const beErrorGetLastCategory = function () {
  const errors = this.$store.getters.peekMessages
  if (errors && errors.length > 0) {
    if (errors[errors.length - 1]?.type !== 'success') {
      return errors[errors.length - 1]?.extensions?.category ? errors[errors.length - 1].extensions.category : null
    }
  }

  return null
}
/**
 * search spezial error code
 */
const beSpecialErrorCode = function (error, code) {
  let specialError = false
  splitError(error).forEach(e => {
    specialError = e.extensions.magma_code === code
  })
  return specialError
}

export default {
  methods: {
    beErrorGetAllMessages,
    beErrorGetLastMessage,
    beErrorGetLastErrorCode,
    beHasMessages,
    beHasErrorMessages,
    beHasSuccessMessage,
    beErrorGetLastCategory,
    beSpecialErrorCode
  }
}

export {
  beSpecialErrorCode
}
